import ViewBase from "../view-base.view";
import AttendanceModel from "../../models/attendance/attendance.model";

export default function AttendanceExcelUploadView() {

  ViewBase.call(this);

  let needRefresh = false;

  let downloadTemplate = () => {
    this.showLoading();

    AttendanceModel.downloadCheckInOutTemplate()
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  let uploadTemplate = (uploadForm) => {
    this.showLoading();

    AttendanceModel.uploadCheckInOutTemplate(uploadForm)
      .then((result) => {
        this.showMessage(
          this.getText('EM00000312', 'Please check the detailed upload result in the downloaded file'),
          this.getText('EM00000313', 'Upload Completed'),
        );
        needRefresh = true;
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  let submitUploadTemplate = (e) => {
    e.preventDefault();
    // Validate upload form
    e.target.classList.add('was-validated');
    if (!e.target.checkValidity()) {
      // console.log('checkValidity');
      e.stopPropagation();
      return;
    }

    let fileInput = document.getElementById('file-upload');
    var files = fileInput.files;
    var uploadFormData = new FormData();
    for (var i = 0; i != files.length; i++) {
      uploadFormData.append("file", files[i]);
    }

    uploadTemplate(uploadFormData);
  }

  let closeModal = function () {
    onClose(false);
  }

  let onClose = (isModalOpen) => { }

  let triggerRefresh = (needRefresh) => { }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.onClose) {
        onClose = vnode.attrs.onClose;
      }

      if (vnode.attrs.triggerRefresh) {
        triggerRefresh = vnode.attrs.triggerRefresh;
      }
    },
    onremove: (vnode) => {
      triggerRefresh(needRefresh);
    },
    view: (vnode) => {
      return [
        m('.container',
          m('ol',
            m('li.fw-bold.mb-4',
              m('.mb-2', this.getText('LT00000218', 'Download Template')),
              m('button.btn.btn-primary', {
                onclick: downloadTemplate
              },
                m('i.bi.bi-file-earmark-arrow-down'), this.getText("LT00000220", "Excel Template")
              ),
            ),
            m('li.fw-bold.mb-4',
              { style: "list-style-type: none;" },
              m('hr')
            ),
            m('li.fw-bold.mb-4',
              { value: 2 },
              m('.mb-2', this.getText('LT00000197', 'Excel Upload')),
              m('form#upload-template-form.row.g-4.fw-normal.needs-validation[novalidate]', { onsubmit: submitUploadTemplate },
                m('.col-12.position-relative',
                  m('input#file-upload.form-control[type=file][required]'),
                  m('.invalid-tooltip', this.getText("EM00000316", "Please select a file")),
                ),
                m('.col-12',
                  m('.d-flex.justify-content-end.mb-3', { style: 'gap: 0.75em' },
                    m('button.btn.btn-primary[type=submit]', this.getText("LT00000290", "Upload")),
                    m('button.btn.btn-white[type=button]', { onclick: closeModal }, this.getText("LT00000021", "Close")),
                  ),
                ),
              ),
            )
          ),
        ),
        this.getBaseViews()
      ]
    }
  }
}
